import { createFileRoute } from "@tanstack/react-router";

import { SubscriptionPage } from "@/features/auth/subscription";

export const Route = createFileRoute("/subscription")({
  component: RouteComponent,
});

function RouteComponent() {
  return <SubscriptionPage />;
}
